<template>
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                 <router-link class="btn btn-lg btn-primary btn-round text-uppercase" to="/home">{{ $t("general.returnBtn") }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "returnBtn"
};
</script>
